import React from "react";
import style from "./style.scss";

export const TabPane = ({ children }) => {
    return children ? <div className={style.pane}>{children}</div> : null;
};
